import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { viewportConfig } from './animations';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';

const categories = ['general', 'pricing', 'technical', 'security'] as const;

const faqCounts: Record<string, number> = {
  general: 4,
  pricing: 4,
  technical: 5,
  security: 4,
};

export function FAQSection() {
  const { t } = useTranslation();

  return (
    <section id="faq" className="py-20 md:py-28 bg-muted/30 scroll-mt-16">
      <div className="container mx-auto px-4">
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={viewportConfig}
          transition={{ duration: 0.6 }}
        >
          <h2 className="text-3xl md:text-4xl font-bold mb-4">{t('landing.faq.title')}</h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">{t('landing.faq.subtitle')}</p>
        </motion.div>

        <motion.div
          className="max-w-3xl mx-auto"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={viewportConfig}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <Tabs defaultValue="general" className="w-full">
            <TabsList className="grid w-full grid-cols-4 mb-8">
              {categories.map((cat) => (
                <TabsTrigger key={cat} value={cat} className="text-sm">
                  {t(`landing.faq.categories.${cat}`)}
                </TabsTrigger>
              ))}
            </TabsList>

            {categories.map((cat) => (
              <TabsContent key={cat} value={cat}>
                <Accordion type="single" collapsible className="w-full">
                  {Array.from({ length: faqCounts[cat] }, (_, i) => (
                    <AccordionItem key={i} value={`${cat}-${i}`}>
                      <AccordionTrigger className="text-left">
                        {t(`landing.faq.${cat}.q${i + 1}`)}
                      </AccordionTrigger>
                      <AccordionContent className="text-muted-foreground">
                        {t(`landing.faq.${cat}.a${i + 1}`)}
                      </AccordionContent>
                    </AccordionItem>
                  ))}
                </Accordion>
              </TabsContent>
            ))}
          </Tabs>
        </motion.div>
      </div>
    </section>
  );
}
